// import { Alert, AlertDescription } from '@chakra-ui/react';

export const FailedToLoad = () => (
  <div>
    Something went wrong. Please try again later or try another payment method.
  </div>
);
